/*
 * @Author: 小周
 * @Date: 2023-09-06 18:06:21
 * @LastEditTime: 2024-06-25 16:11:32
 * @LastEditors: MrZHLF
 * @Description:
 */

import { createSlice } from '@reduxjs/toolkit'

import { getToken } from '@/utils/tokenStore'

import { getUser } from '@/utils/userStore'
export const userReducer = createSlice({
  name: 'user',
  initialState: {
    title: '小周先生',
    token: null || getToken(),
    userInfo: {} || getUser(),
    count: 0,
  },
  reducers: {
    increment: (state) => {
      state.count += 1
    },
    decrement: (state) => {
      state.count -= 1
    },
    // 设置token
    setToken: (state, { payload }) => {
      state.token = payload
    },
    // 设置用户信息
    setUserInfo: (state, { payload }) => {
      state.userInfo = payload
    },
    setTitle: (state, { payload }) => {
      state.title = payload
    },
  },
})

export const { increment, decrement, setTitle, setToken, setUserInfo } =
  userReducer.actions

export default userReducer.reducer
